import {t} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';

function MyMaintenanceGradeLoading() {
  return (
    <section className="section section_certification_management">
      <div className="section_container_header">
        <h3 className="title_medium_b">{t('T20225')}</h3>
      </div>
      <div
        className="section_container skeleton"
        style={{height: 466}}
      />
    </section>
  );
}

export default MyMaintenanceGradeLoading;
